import { apiGateway } from "@/_old/services/api-gateway";
import {
  GetCompanyHighlightsParams,
  GetCompanyHighlightsResponse,
} from "@/company/types";

const getCompanyHighlights = async (
  params: GetCompanyHighlightsParams,
  signal?: AbortSignal,
): Promise<GetCompanyHighlightsResponse> => {
  const { data }: { status: number; data: GetCompanyHighlightsResponse } =
    await apiGateway.get(`/companies/${params.companyId}/stats-overview`, {
      signal,
    });

  return data;
};

export { getCompanyHighlights };
